export function setCalculationUidCookie(calculationUid: string): void {
    if (calculationUid) {
        const timestamp = Date.now();
        const cookieValue = `${calculationUid}|${timestamp}`;
        document.cookie = `calculationUid=${cookieValue}; path=/; max-age=${60 * 60 * 24 * 30}`;
    }
}

export function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop()?.split(";").shift() || null;
    }
    return null;
}

export function deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function parseCalculationUidCookie(cookieValue: string): { uid: string; createdAt: Date } | null {
    if (!cookieValue) return null;

    const parts = cookieValue.split("|");
    if (parts.length === 2) {
        const uid = parts[0];
        const timestamp = parseInt(parts[1]);
        if (!isNaN(timestamp)) {
            return { uid, createdAt: new Date(timestamp) };
        }
    }

    return { uid: cookieValue, createdAt: new Date() };
}
